import $ from 'jquery'

$(document).ready(function () {
  initYouTubeVideoPreview()
})

function initYouTubeVideoPreview() {
  // Handle play button clicks
  $('.dhsv_video_player_modal__play-btn').on('click', function (e) {
    e.preventDefault()
    e.stopPropagation()
    
    const $button = $(this)
    const videoId = $button.data('video-id')
    const $modal = $(`#${videoId}`)
    const $container = $button.closest('.dhsv_video_player_modal')
    const youtubeUrl = $container.data('youtube-url')
    
    if (youtubeUrl && youtubeUrl.trim() !== '' && $modal.length) {
      // Set the iframe source
      const $iframe = $modal.find('iframe')
      $iframe.attr('src', youtubeUrl)
      
      // Show the modal
      $modal.addClass('show')
      $('body').addClass('no-scroll')
      
      // Store scroll position
      const scrollTop = $(window).scrollTop()
      $('body').css('top', `-${scrollTop}px`)
      
      // Focus management for accessibility
      $modal.attr('aria-hidden', 'false')
      $iframe.focus()
    } else {
      console.warn('YouTube Video Player Modal: No valid YouTube URL provided')
    }
  })
  
  // Handle modal close
  $('.youtube-video-modal .close-modal').on('click', function (e) {
    e.preventDefault()
    e.stopPropagation()
    
    const $modal = $(this).closest('.youtube-video-modal')
    closeYouTubeModal($modal)
  })
  
  // Handle clicking outside modal to close
  $('.youtube-video-modal').on('click', function (e) {
    if (e.target === this) {
      closeYouTubeModal($(this))
    }
  })
  
  // Handle ESC key to close modal
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      const $openModal = $('.youtube-video-modal.show')
      if ($openModal.length) {
        closeYouTubeModal($openModal)
      }
    }
  })
  
  // Handle container click - always open modal when clicking on image
  $('.dhsv_video_player_modal__container').on('click', function (e) {
    const $container = $(this).closest('.dhsv_video_player_modal')
    const $playBtn = $(this).find('.dhsv_video_player_modal__play-btn')
    const youtubeUrl = $container.data('youtube-url')
    const videoId = $container.data('video-id')
    const $modal = $(`#${videoId}`)
    
    // If there's a play button and we clicked on it, let the play button handler take over
    if ($playBtn.length && $(e.target).closest('.dhsv_video_player_modal__play-btn').length) {
      return // Let the play button click handler work
    }
    
    // Otherwise, open modal directly
    if (youtubeUrl && youtubeUrl.trim() !== '' && $modal.length) {
      // Set the iframe source
      const $iframe = $modal.find('iframe')
      $iframe.attr('src', youtubeUrl)
      
      // Show the modal
      $modal.addClass('show')
      $('body').addClass('no-scroll')
      
      // Store scroll position
      const scrollTop = $(window).scrollTop()
      $('body').css('top', `-${scrollTop}px`)
      
      // Focus management for accessibility
      $modal.attr('aria-hidden', 'false')
      $iframe.focus()
    } else {
      console.warn('YouTube Video Player Modal: No valid YouTube URL provided')
      console.log('YouTube URL:', youtubeUrl)
      console.log('Modal element:', $modal.length)
      console.log('Container data:', $container.data())
    }
  })
}

function closeYouTubeModal($modal) {
  // Remove the iframe source to stop video playback
  const $iframe = $modal.find('iframe')
  $iframe.attr('src', '')
  
  // Hide the modal
  $modal.removeClass('show')
  $('body').removeClass('no-scroll')
  
  // Restore scroll position
  const scrollTop = parseInt($('body').css('top') || '0', 10) * -1
  $('body').css('top', '')
  $(window).scrollTop(scrollTop)
  
  // Update accessibility attributes
  $modal.attr('aria-hidden', 'true')
}

// Export for potential use in other modules
window.YouTubeVideoPreview = {
  init: initYouTubeVideoPreview,
  closeModal: closeYouTubeModal
}
